import { render, staticRenderFns } from "./SalaryTotalContributionAndTaxes.vue?vue&type=template&id=24fec47a&scoped=true&"
import script from "./SalaryTotalContributionAndTaxes.vue?vue&type=script&lang=js&"
export * from "./SalaryTotalContributionAndTaxes.vue?vue&type=script&lang=js&"
import style0 from "./SalaryTotalContributionAndTaxes.vue?vue&type=style&index=0&id=24fec47a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24fec47a",
  null
  
)

export default component.exports